import React from 'react';
import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import './style.scss'




function ImageUpload(props) {
  return (
    <FilePond
      allowMultiple={true}
      maxFiles={1}
      // server={`${process.env.REACT_APP_XML_TO_JSON}api/v1/excel/getdata`}
      server={{
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          let progressVal = 0;
          const interval = setInterval(() => {
            progressVal += 10;
            progress(true, progressVal, 100);
            if (progressVal >= 100) {
              clearInterval(interval);
              load(Date.now().toString());
            }
          }, 150);

          return {
            abort: () => {
              clearInterval(interval);
              abort();
            },
          };
        },
      }}
      acceptedFileTypes={props.filesAccepted}
      labelFileTypeNotAllowed={props.lng("po_management_upload_file_invalid_file_format")}
      labelTapToUndo=''
      labelFileProcessingComplete={props.lng("po_management_upload_complete")}
      maxFileSize={props.maxSizeFile}
      labelIdle={props.lng("po_management_upload_file_placeholder")}
      fileValidateTypeLabelExpectedTypes={props.fileValidateTypeLabelExpectedTypes}
      labelMaxFileSizeExceeded={props.labelMaxFileSizeExceeded}
      labelMaxFileSize={props.labelMaxFileSize}
      labelFileProcessing={props.lng('po_management_uploading')}
      labelTapToCancel={props.lng('po_management_upload_tap_to_cancel')}
      onprocessfile={(error, file) => {
        if (!error) {
          props.callFile(file)
        }
      }}
      onremovefile={() => {
        props.callFile()
      }}
    />
  );
}

export default ImageUpload;
